import { RoutesType } from 'Shared/Routes';
import {VenueRoutes as SharedRoutes } from 'Shared/routes/VenueRoutes';
import { lazy } from 'solid-js';


export class DifferentDrummerRoutes extends SharedRoutes
{
	frontend()
	{
		return ({
			...super.frontend(),

			'/food':	lazy(() => import('Shared/frontend/menuPage/MenuPage')),
			'/drinks':	lazy(() => import('Shared/frontend/menuPage/MenuPage')),
		}) as RoutesType;
	}

	backend()
	{
		return ({
			...super.backend(),
		}) as RoutesType;
	}
}

